define('OutSystems/ClientRuntime/ResourceCache',["require", "exports", "tslib", "./ApplicationInfo", "./Logger", "./modules/Common/UrlUtils", "./NativeHelper", "./Request"], function (require, exports, tslib_1, ApplicationInfo_1, Logger, UrlUtils_1, NativeHelper, Request) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.forceDummyCacheHandler = exports.ResourceCache = void 0;
    var ResourceCacheModule = "ResourceCache";
    var AbstractCacheHandler = (function () {
        function AbstractCacheHandler() {
            this.isCaching = false;
            this.errorMessages = [];
            this.onFinishListeners = [];
            this.onErrorListeners = [];
            this.onProgressListeners = [];
            Logger.trace(ResourceCacheModule, "Initializing resource cache using '" + this.getCacheName() + "' mechanism");
        }
        AbstractCacheHandler.prototype.onFinish = function () {
            this.isCaching = false;
            Logger.trace(ResourceCacheModule, "Caching finished");
            this.onFinishListeners.forEach(function (listener) { return listener(); });
            this.onFinishListeners = [];
            this.onErrorListeners = [];
            this.onProgressListeners = [];
        };
        AbstractCacheHandler.prototype.onError = function (reason) {
            Logger.trace(ResourceCacheModule, "Caching error: ".concat(reason));
            this.errorMessages.push(reason);
            this.onErrorListeners.forEach(function (listener) { return listener(reason); });
        };
        AbstractCacheHandler.prototype.onProgress = function (loaded, total) {
            Logger.trace(ResourceCacheModule, "Caching progress: ".concat(loaded, " / ").concat(total));
            this.onProgressListeners.forEach(function (listener) { return listener(loaded, total); });
        };
        AbstractCacheHandler.prototype.listen = function (onFinish, onError, onProgress) {
            Logger.trace(ResourceCacheModule, "Started listening to resource cache events");
            if (this.errorMessages.length > 0 && !!onError) {
                onError(this.errorMessages.join("\n"));
            }
            if (!this.isCaching && !!onFinish) {
                onFinish();
            }
            if (this.isCaching) {
                if (!!onFinish) {
                    this.onFinishListeners.push(onFinish);
                }
                if (!!onError) {
                    this.onErrorListeners.push(onError);
                }
                if (!!onProgress) {
                    this.onProgressListeners.push(onProgress);
                }
            }
            else {
                Logger.trace(ResourceCacheModule, "Resource caching was already finished, listeners not attached");
            }
        };
        AbstractCacheHandler.prototype.start = function (manifest) {
            var _this = this;
            Logger.trace(ResourceCacheModule, "Started caching resources for version ".concat(manifest.versionToken));
            return new Promise(function (resolve, reject) {
                if (!_this.isCaching) {
                    try {
                        _this.isCaching = true;
                        _this.errorMessages = [];
                        _this.innerStart(manifest);
                    }
                    catch (e) {
                        _this.onError(e.message);
                        reject(e.message);
                        return;
                    }
                }
                var promiseState = { finished: false };
                _this.listen(function () {
                    if (!promiseState.finished) {
                        promiseState.finished = true;
                        resolve();
                    }
                }, function (reason) {
                    if (!promiseState.finished) {
                        promiseState.finished = true;
                        reject(reason);
                    }
                }, null);
            });
        };
        AbstractCacheHandler.prototype.switch = function (versionToken) {
            Logger.trace(ResourceCacheModule, "Switching cached resources to version ".concat(versionToken));
            this.innerSwitch(versionToken);
        };
        return AbstractCacheHandler;
    }());
    var NativeCacheHandler = (function (_super) {
        tslib_1.__extends(NativeCacheHandler, _super);
        function NativeCacheHandler() {
            var _this = _super.call(this) || this;
            _this.isNativeReady = false;
            _this.isCacheAvailable = false;
            NativeHelper.ensureNativeReady().then(function () {
                _this.isNativeReady = true;
                _this.isCacheAvailable = typeof OSCache !== "undefined";
                if (!_this.isCacheAvailable) {
                    Logger.error(ResourceCacheModule, NativeCacheHandler.OSCacheNotFoundMessage);
                    return;
                }
                OSCache.addEventListener("onfinish", function (e) { return _this.onFinish(); });
                OSCache.addEventListener("onerror", function (e) { return _this.onError(e.message); });
                OSCache.addEventListener("onprogress", function (e) { return _this.onProgress(e.loaded, e.total); });
            }, function (e) {
                Logger.error(ResourceCacheModule, "OSCache was not initialized because Cordova was not loaded.", e);
            });
            return _this;
        }
        NativeCacheHandler.prototype.checkOSCacheAndDeferCall = function (propagateErrors, callbackToDefer) {
            if (!this.isNativeReady) {
                Logger.trace(ResourceCacheModule, "OSCache call deferred until Cordova is loaded");
                NativeHelper.ensureNativeReady().then(callbackToDefer);
                return false;
            }
            else if (!this.isCacheAvailable) {
                if (propagateErrors) {
                    this.onError(NativeCacheHandler.OSCacheNotFoundMessage);
                }
                return false;
            }
            return true;
        };
        NativeCacheHandler.prototype.getCacheName = function () {
            return "Native Cache";
        };
        NativeCacheHandler.prototype.innerStart = function (manifest) {
            var _this = this;
            if (!this.checkOSCacheAndDeferCall(true, function () { return _this.innerStart(manifest); })) {
                return;
            }
            var basePath = (0, ApplicationInfo_1.getBasePath)();
            var homeModulePath = "/".concat((0, ApplicationInfo_1.getHomeModuleName)(), "/");
            var urls = [];
            for (var _i = 0, _a = Object.getOwnPropertyNames(manifest.urlVersions); _i < _a.length; _i++) {
                var baseUrl = _a[_i];
                urls.push((0, UrlUtils_1.buildURLFromVersionedResource)((0, UrlUtils_1.replaceBasePath)(baseUrl, homeModulePath, basePath), manifest.urlVersions[baseUrl]));
            }
            Logger.trace(ResourceCacheModule, "Start Caching... ".concat(urls.length, " files: "));
            for (var i = 0; i < urls.length; i++) {
                Logger.trace(ResourceCacheModule, "".concat(i + 1, "/").concat(urls.length, ": ").concat(urls[i]));
            }
            OSCache.startCaching(manifest.versionToken, urls, manifest.urlMappings, manifest.urlMappingsNoCache);
        };
        NativeCacheHandler.prototype.innerSwitch = function (versionToken) {
            var _this = this;
            if (!this.checkOSCacheAndDeferCall(false, function () { return _this.innerSwitch(versionToken); })) {
                return;
            }
            try {
                OSCache.switchToVersion(versionToken);
            }
            catch (e) {
                Logger.error(ResourceCacheModule, e);
            }
        };
        NativeCacheHandler.OSCacheNotFoundMessage = "OSCache not found (is a native plugin missing?)";
        return NativeCacheHandler;
    }(AbstractCacheHandler));
    var PreloaderCacheHandler = (function (_super) {
        tslib_1.__extends(PreloaderCacheHandler, _super);
        function PreloaderCacheHandler() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.requested = 0;
            _this.resourceQueue = [];
            _this.count = 0;
            _this.total = 0;
            return _this;
        }
        PreloaderCacheHandler.prototype.getCacheName = function () {
            return "Preloader";
        };
        PreloaderCacheHandler.prototype.innerStart = function (manifest) {
            if (this.isOngoing()) {
                return;
            }
            this.count = this.requested = this.total = 0;
            this.resources = manifest.urlVersions;
            if (!this.resources) {
                return;
            }
            this.resourceQueue = Object.getOwnPropertyNames(this.resources);
            this.total = this.resourceQueue.length;
            if (this.resourceQueue.length <= 0) {
                return;
            }
            var basePath = (0, ApplicationInfo_1.getBasePath)();
            var homeModulePath = "/".concat((0, ApplicationInfo_1.getHomeModuleName)(), "/");
            for (var i = 0; i < PreloaderCacheHandler.DefaultWindowSize; ++i) {
                this.prefetchNext(homeModulePath, basePath);
            }
        };
        PreloaderCacheHandler.prototype.innerSwitch = function (versionToken) {
        };
        PreloaderCacheHandler.prototype.isOngoing = function () {
            return this.requested > 0 || this.resourceQueue.length > 0;
        };
        PreloaderCacheHandler.prototype.prefetchNext = function (homeModulePath, basePath) {
            var _this = this;
            var resourceBaseUrl = this.resourceQueue.pop();
            var url = (0, UrlUtils_1.buildURLFromVersionedResource)((0, UrlUtils_1.replaceBasePath)(resourceBaseUrl, homeModulePath, basePath), this.resources[resourceBaseUrl]);
            Logger.trace(ResourceCacheModule, "Requesting resource: ".concat(url));
            Request.createHttpRequest({ method: "GET", url: url }).then(function (request) {
                request.onSuccess =
                    request.onError =
                        request.onTimeout =
                            function (response) {
                                if (!!_this.onError && (!response.complete || response.statusCode !== 200)) {
                                    _this.onError("Failed to load resource '".concat(url, "' with status: ").concat(response.statusText));
                                }
                                if (!!_this.onProgress) {
                                    _this.onProgress(++_this.count, _this.total);
                                }
                                _this.requested--;
                                if (_this.resourceQueue.length === 0 && _this.requested === 0) {
                                    if (!!_this.onFinish) {
                                        _this.onFinish();
                                    }
                                }
                                else if (_this.resourceQueue.length > 0) {
                                    _this.prefetchNext(homeModulePath, basePath);
                                }
                            };
                request.setTimeout(PreloaderCacheHandler.DefaultResourceTimeout);
                request.send();
            });
            this.requested++;
        };
        PreloaderCacheHandler.DefaultWindowSize = 2;
        PreloaderCacheHandler.DefaultResourceTimeout = 20000;
        return PreloaderCacheHandler;
    }(AbstractCacheHandler));
    var DummyCacheHandler = (function (_super) {
        tslib_1.__extends(DummyCacheHandler, _super);
        function DummyCacheHandler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DummyCacheHandler.prototype.getCacheName = function () {
            return "Dummy";
        };
        DummyCacheHandler.prototype.innerStart = function (manifest) {
            this.onFinish();
        };
        DummyCacheHandler.prototype.innerSwitch = function (versionToken) { };
        return DummyCacheHandler;
    }(AbstractCacheHandler));
    function getResourcesCacheHandler() {
        if (typeof document === "undefined") {
            return new DummyCacheHandler();
        }
        else if (NativeHelper.isRunningOnNative()) {
            return new NativeCacheHandler();
        }
        else {
            return new PreloaderCacheHandler();
        }
    }
    exports.ResourceCache = getResourcesCacheHandler();
    function forceDummyCacheHandler() {
        exports.ResourceCache = new DummyCacheHandler();
    }
    exports.forceDummyCacheHandler = forceDummyCacheHandler;
});
//# sourceMappingURL=ResourceCache.js.map;
